import Skeleton from '@mui/material/Skeleton';
import * as React from 'react';

interface IDataGridRowSkeleton {
  children: React.ReactNode;
  isFetching: boolean;
}

export function DataGridRowSkeleton({ children, isFetching }: IDataGridRowSkeleton) {
  return isFetching ? <Skeleton animation="wave" height={25} width="80%" /> : children;
}
